export default "<div class=\"resize-container\">\n\t<div class=\"fas fa-angle-left fa-xs\"></div>\n\t<div class=\"fas fa-angle-right fa-xs\"></div>\n</div>\n"